"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFrequencyCapProperty = exports.frequencyCapPropertyDefinition = void 0;
exports.frequencyCapPropertyDefinition = {
    view: {
        label: 'Frequency cap',
        hint: 'How often the promotion should be shown to the user',
    },
    constraints: [
        {
            name: 'max',
            argument: 20,
        },
        {
            name: 'min',
            argument: 1,
        },
    ],
    type: 'int',
    multiple: false,
    name: 'frequency-cap',
};
const isFrequencyCapProperty = (prop) => {
    return prop.name === exports.frequencyCapPropertyDefinition.name;
};
exports.isFrequencyCapProperty = isFrequencyCapProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJlcXVlbmN5LWNhcC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ZyZXF1ZW5jeS1jYXAucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsZUFBZTtRQUN0QixJQUFJLEVBQUUscURBQXFEO0tBQzVEO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsS0FBSztZQUNYLFFBQVEsRUFBRSxFQUFFO1NBQ2I7UUFDRDtZQUNFLElBQUksRUFBRSxLQUFLO1lBQ1gsUUFBUSxFQUFFLENBQUM7U0FDWjtLQUNGO0lBQ0QsSUFBSSxFQUFFLEtBQUs7SUFDWCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9